module.exports = __webpack_public_path__ + "fonts/Roboto-400-cyrillic2.71a33b6.woff2";